export default __webpack_public_path__ + "static/media/P-012.8e540caf.png";